import React from 'react';
import { Icon } from '@block/plug';
import PropTypes from 'prop-types';
import './index.scss';

interface Props {
  onDelete: () => void;
  hideIcon?: boolean;
}

class Card extends React.Component<Props> {
  // componentWillReceiveProps(nextProps) {
  //   return true;
  // }
  static propTypes: any;

  static defaultProps: any;

  handleDelete = () => {
    const { onDelete } = this.props;
    if (typeof onDelete === 'function') {
      onDelete();
    }
  };

  render() {
    const { children, hideIcon = false } = this.props;
    return (
      <div className="card">
        {!hideIcon && <Icon type="delete-o" className="card__icon" onClick={this.handleDelete} />}
        {children}
      </div>
    );
  }
}

Card.propTypes = {
  onDelete: PropTypes.func,
  children: PropTypes.node,
};

Card.defaultProps = {
  onDelete: null,
  children: null,
};

export default Card;
